var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M12 15.625c3.314 0 6-2.798 6-6.25s-2.686-6.25-6-6.25-6 2.798-6 6.25 2.686 6.25 6 6.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.906 21.094A10.73 10.73 0 0 1 6.75 17.09 10.2 10.2 0 0 1 12 15.624c1.843 0 3.654.506 5.25 1.466a10.73 10.73 0 0 1 3.844 4.004"
})));
export default SvgUser;